/* eslint-disable react/jsx-indent */
/* eslint-disable indent */
/* eslint-disable camelcase */
/* eslint-disable multiline-ternary */
import React, { Fragment, useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import { PropTypes } from 'prop-types'
import { styled } from '@mui/material/styles'
import IconButton from '@mui/material/IconButton'
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip'
import InfoIcon from '@mui/icons-material/Info'
import { TextField, Typography } from '@mui/material'
import FormGroup from '@mui/material/FormGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import { useDispatch, useSelector } from 'react-redux'
import config from '../../config/config'
import { setPedestrianInputs } from '../../slices/criteriaSelection/pedestrian'
import { setBicycleInputs } from '../../slices/criteriaSelection/bicycle'
import { setAutoInputs } from '../../slices/criteriaSelection/auto'
import { setFreightInputs } from '../../slices/criteriaSelection/freight'
import {
  clearAllHCTAmenities,
  removeHCTAmenitiesInput,
  removeTransitStopAmenitiesInput,
  setTransitInputs
} from '../../slices/criteriaSelection/transit'
import { calculatePedestrianScore } from '../../utils/pedestrianScore'
import {
  ACTIVE_BUILDING_FRONTAGE,
  BUFFER_QUALITY,
  BUFFER_WIDTH,
  COMFORT_ZONE_WIDTH,
  CROSSING_IMPROVEMENTS,
  CROSSING_IMPROVEMENTS_VALUES,
  LANDSCAPE_BUFFER_STREET_TREES,
  LIGHTING,
  LIGHTING_VALUES,
  PEDESTRIAN_FACILITY_TYPE,
  PEDESTRIAN_FACILITY_TYPE_VALUES,
  SIDEWALK_ACCESSIBILITY,
  SIDEWALK_QUALTIY,
  USABLE_SIDEWALK_WIDTH
} from '../../constants/pedestrian'
import { calculateBikeScore } from '../../utils/bikeScore.js'
import {
  BIKE_FACILITY_TYPE,
  BIKE_FACILITY_TYPE_VALUES,
  BUFFER_BIKE_SIDEWALK,
  BUFFER_BIKE_TRAVEL_LANE,
  CURBSIDE_MANAGEMENT,
  LATERAL_DISTANCE_BETWEEN_MARKINGS_AND_EDGE_OF_SIDEWALK_OR_PARKED_CARS,
  SHARED_LANE_PAVEMENT_MARKINGS_PRESENT,
  SIDEWALK_WIDTH,
  SPECIAL_CONSIDERATIONS,
  STREET_BUFFER_WIDTH,
  USABLE_BIKEWAY_WIDTH
} from '../../constants/bike'
import { calculateTransitScore } from '../../utils/transitScore'
import { calculateFreightScore } from '../../utils/freightScore'
import { calculateAutoScore } from '../../utils/autoScore'
import { setFinalScores } from '../../slices/finalScores'
import {
  HCT_AMENITIES,
  HCT_AMENITIES_VALUES,
  HIGH_CAPACITY_TRANSIT_FACILITY,
  HIGH_CAPACITY_TRANSIT_FACILITY_VALUES,
  TRANSIT_STOP_AMENITIES_VALUES
} from '../../constants/transit'
import { calculateVCRatio } from '../../utils/calculateVCRatio'
import { setPedestrianStreetmixInput } from '../../utils/pedestrianStreetmixInput.utils'
import { setbikeStreetmixInput } from '../../utils/bikeStreetmixInput.utils'
import { setTransitStreetmixInput } from '../../utils/transitStreetmixInput.utils'
import { setFreightStreetmixInput } from '../../utils/freightStreetmixInput.utils'
import {
  setAmenitiesNotSeenOnStreetmix,
  setShareableURL
} from '../../slices/appSlice'
import { remixStreet } from '../../../streets/remix'
import {
  HIGH_CAPACITY_TRANSIT,
  LAND_USE_CONTEXT,
  NO,
  PREVAILING_POSTED_SPEED,
  TRAVEL_LANES,
  YES
} from '../../constants/roadwayVariables'
import ProjectInfo from '../ProjectInputs/ProjectInfo'
import { NA } from '../../constants/scores'
import { VC } from '../../constants/auto'
import './ModalCriteria.scss'

export const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip
    {...props}
    classes={{ popper: className }}
    sx={{ alignSelf: 'center' }}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: 14,
    border: '1px solid #dadde9',
    boxShadow: theme.shadows[1]
  }
}))

export default function ModalCriteria({ modalConfig, travellerType }) {
  const { scores } = useSelector((state) => state[travellerType])
  const dispatch = useDispatch()
  const avgScore = useSelector((state) => state.finalScores[travellerType])
  const { high_capacity_transit } = useSelector(
    (state) => state.roadwayVariables
  )
  const tier = useSelector(
    (state) =>
      state.modalTiers[travellerType[0].toUpperCase() + travellerType.slice(1)]
  )
  const { pedestrian_facility_type } = useSelector((state) => state.pedestrian)
  const { bike_facility_type } = useSelector((state) => state.bicycle)
  const [hiddenFields, setHiddenFields] = useState([])

  useEffect(() => {
    if (travellerType !== 'pedestrian') {
      return
    }
    // Hide feilds based on Pedestrian Facility Types
    if (pedestrian_facility_type === PEDESTRIAN_FACILITY_TYPE_VALUES[0]) {
      // DETAHCED SIDEWALKS
      setHiddenFields([COMFORT_ZONE_WIDTH])
    } else if (
      pedestrian_facility_type === PEDESTRIAN_FACILITY_TYPE_VALUES[1]
    ) {
      // ATTACHED SIDEWALKS
      setHiddenFields([
        COMFORT_ZONE_WIDTH,
        BUFFER_WIDTH,
        BUFFER_QUALITY,
        LANDSCAPE_BUFFER_STREET_TREES
      ])
    } else {
      // NO SIDEWALKS
      setHiddenFields([
        USABLE_SIDEWALK_WIDTH,
        BUFFER_WIDTH,
        BUFFER_QUALITY,
        LANDSCAPE_BUFFER_STREET_TREES,
        SIDEWALK_QUALTIY,
        ACTIVE_BUILDING_FRONTAGE,
        SIDEWALK_ACCESSIBILITY,
        CROSSING_IMPROVEMENTS
      ])
    }
  }, [pedestrian_facility_type, travellerType])

  useEffect(() => {
    if (travellerType !== 'transit') {
      return
    }
    // Hide High capacoty transit amenities if high capacoty trasnit is NO
    if (high_capacity_transit === NO) {
      setHiddenFields([HCT_AMENITIES])
    } else {
      setHiddenFields([])
    }
  }, [high_capacity_transit, travellerType])

  useEffect(() => {
    if (travellerType !== 'bicycle') {
      return
    }
    // Hide feilds based on BIKE Facility Types
    if (bike_facility_type === BIKE_FACILITY_TYPE_VALUES[0]) {
      // NO BIKE LANES
      setHiddenFields([
        STREET_BUFFER_WIDTH,
        BUFFER_BIKE_TRAVEL_LANE,
        USABLE_BIKEWAY_WIDTH,
        CURBSIDE_MANAGEMENT,
        BUFFER_BIKE_SIDEWALK,
        SIDEWALK_WIDTH,
        SPECIAL_CONSIDERATIONS
      ])
    } else if (bike_facility_type === BIKE_FACILITY_TYPE_VALUES[1]) {
      //  NO BIKE LANE BUFFER
      setHiddenFields([
        STREET_BUFFER_WIDTH,
        BUFFER_BIKE_TRAVEL_LANE,
        BUFFER_BIKE_SIDEWALK,
        SIDEWALK_WIDTH,
        SHARED_LANE_PAVEMENT_MARKINGS_PRESENT,
        LATERAL_DISTANCE_BETWEEN_MARKINGS_AND_EDGE_OF_SIDEWALK_OR_PARKED_CARS
      ])
    } else if (
      bike_facility_type === BIKE_FACILITY_TYPE_VALUES[2] ||
      bike_facility_type === BIKE_FACILITY_TYPE_VALUES[4]
    ) {
      // ONE OR TWO ROADWAY BIKE LANES
      setHiddenFields([
        BUFFER_BIKE_SIDEWALK,
        SIDEWALK_WIDTH,
        SHARED_LANE_PAVEMENT_MARKINGS_PRESENT,
        LATERAL_DISTANCE_BETWEEN_MARKINGS_AND_EDGE_OF_SIDEWALK_OR_PARKED_CARS
      ])
    } else {
      // ONE OR TWO RAISED BIKE LANES
      setHiddenFields([
        SHARED_LANE_PAVEMENT_MARKINGS_PRESENT,
        LATERAL_DISTANCE_BETWEEN_MARKINGS_AND_EDGE_OF_SIDEWALK_OR_PARKED_CARS
      ])
    }
  }, [bike_facility_type, travellerType])

  // useEffect(() => {
  //   if (Object.keys(scores).length) {
  //     // Filter out the keys, which have valid scores
  //     const fileteredScores = Object.keys(scores).filter(
  //       (key) => scores[key] !== 'NA'
  //     )

  //     const sum = fileteredScores.reduce((sum, key) => sum + scores[key], 0)
  //     if (fileteredScores.length) {
  //       const avg = (sum / fileteredScores.length).toFixed(1)
  //       dispatch(setFinalScores({ field: travellerType, value: avg }))
  //     } else {
  //       dispatch(setFinalScores({ field: travellerType, value: 0 }))
  //     }
  //   }
  // }, [scores, travellerType])

  useEffect(() => {
    // Calculate VC when component mounts

    const vcRatio = calculateVCRatio()
    dispatch(setAutoInputs({ field: 'vc', value: vcRatio }))
    dispatch(setTransitInputs({ field: 'vc', value: vcRatio }))
  }, [])

  return (
    <Box
      sx={{
        flexGrow: 1,
        height: '600px',
        overflowY: 'scroll',
        paddingRight: '1.5rem'
      }}
      className="scrollbar-styling"
    >
      {/** Show this tooltip, when tier is NA */}
      {tier === 0 && (
        <ProjectInfo
          infoText={`${
            travellerType === 'bicycle'
              ? 'Bike'
              : travellerType[0].toUpperCase() + travellerType.slice(1)
          } tier is N/A. To activate this tab, return to Set Up Your Project on the previous page and adjust the slider for this user to a value between 1 and 3.`}
        />
      )}
      {config[modalConfig].map((input, index) => {
        // travellerType === 'transit' &&
        // input.id === HIGH_CAPACITY_TRANSIT_FACILITY && (
        // high_capacity_transit !== 'Yes' ? (
        //   ''
        // ) :
        // DO NOT SHOW HIDDEN FIELDS
        return (
          !hiddenFields.includes(input.id) && (
            <ModalCriteriaRows
              key={`${input.name}-${index}`}
              input={input}
              index={index}
              travellerType={travellerType}
            />
          )
        )
      })}
      {/** Comment Avg.score */}
      {/* <Typography
        variant="h2"
        sx={{
          color: config.themeConfig.primaryColor,
          fontWeight: 700,
          m: '1em',
          textAlign: 'center',
          fontSize: 24
        }}
      >
        Average Score : {avgScore}
      </Typography> */}
    </Box>
  )
}

function ModalCriteriaRows({ input, travellerType }) {
  const [hctAmenitiesValues, setHctAmenitiesValues] = useState([])
  const {
    land_use_context,
    travel_lanes,
    high_capacity_transit,
    prevailing_posted_speed
  } = useSelector((state) => state.roadwayVariables)
  const autoScore = useSelector((state) => state.auto.scores.vc)
  const hctValue = useSelector(
    (state) => state.transit.high_capacity_transit_facility
  )
  const { vc } = useSelector((state) => state.auto)
  const transitVC = useSelector((state) => state.transit.vc)
  const autoVC = useSelector((state) => state.auto.vc)
  const defaultModalTier = useSelector(
    (state) =>
      state.modalTiers[travellerType[0].toUpperCase() + travellerType.slice(1)]
  )
  const [err, setErr] = useState(false)
  const [transitVCComment, setTransitVCComment] = useState('')
  const [autoVCComment, setAutoVCComment] = useState('')
  const [bikeSpeedScore, setBikeSpeedScore] = useState(NA)
  const [bikeLaneScore, setBikeLaneScore] = useState(NA)
  const { scores } = useSelector((state) => state[travellerType])
  const bikeFacilityType = useSelector(
    (state) => state.bicycle.bike_facility_type
  )
  const usableBikewayWidthScore = useSelector(
    (state) => state.bicycle.scores.usable_bikeway_width
  )
  const bufferBikeTravelLaneScore = useSelector(
    (state) => state.bicycle.scores.buffer_bike_travel_lane
  )
  const defaultValue = useSelector((state) => state[travellerType][input.id])
  const dispatch = useDispatch()
  const toolTipText =
    input.inputProps &&
    `Enter value between ${input.inputProps.min} and ${input.inputProps.max}`

  useEffect(() => {
    hctValue === HIGH_CAPACITY_TRANSIT_FACILITY_VALUES[1]
      ? setHctAmenitiesValues(HCT_AMENITIES_VALUES.slice(0, 3))
      : hctValue === HIGH_CAPACITY_TRANSIT_FACILITY_VALUES[2]
      ? setHctAmenitiesValues(HCT_AMENITIES_VALUES.slice(3, 7))
      : hctValue === HIGH_CAPACITY_TRANSIT_FACILITY_VALUES[0]
      ? setHctAmenitiesValues(HCT_AMENITIES_VALUES.slice(7, 11))
      : setHctAmenitiesValues(HCT_AMENITIES_VALUES.slice(11, 15))
  }, [hctValue])

  useEffect(() => {
    // When bike facitlity tyep changes , print bike lane and speed scores
    if (
      bikeFacilityType === BIKE_FACILITY_TYPE_VALUES[0] ||
      bikeFacilityType === BIKE_FACILITY_TYPE_VALUES[1]
    ) {
      setBikeSpeedScore(usableBikewayWidthScore)
      setBikeLaneScore(usableBikewayWidthScore)
    } else {
      setBikeSpeedScore(bufferBikeTravelLaneScore)
      setBikeLaneScore(bufferBikeTravelLaneScore)
    }
  }, [bikeFacilityType, usableBikewayWidthScore, bufferBikeTravelLaneScore])

  function handleChange(e) {
    switch (travellerType) {
      case 'pedestrian':
        dispatch(
          setPedestrianInputs({
            field: input.id,
            value: Number(e.target.value)
          })
        )
        break
      case 'bicycle':
        dispatch(
          setBicycleInputs({ field: input.id, value: Number(e.target.value) })
        )
        break
      case 'auto':
        dispatch(
          setAutoInputs({ field: input.id, value: Number(e.target.value) })
        )
        break
      case 'freight':
        dispatch(
          setFreightInputs({ field: input.id, value: Number(e.target.value) })
        )
        break
      case 'transit':
        dispatch(
          setTransitInputs({ field: input.id, value: Number(e.target.value) })
        )
        break
      default:
    }
  }

  useEffect(() => {
    if (vc !== '') {
      calculateAutoScore()
    }
  }, [vc])

  useEffect(() => {
    if (
      Number(transitVC) > 0.9 &&
      high_capacity_transit === YES &&
      hctValue === HIGH_CAPACITY_TRANSIT_FACILITY_VALUES[3]
    ) {
      setTransitVCComment(' This is a candidate  for dedicated transit lanes.')
    } else {
      // In case above conditions are not met, do not show any comment
      setTransitVCComment('')
    }
  }, [transitVC, hctValue, high_capacity_transit])

  useEffect(() => {
    if (autoVC < 0.5) {
      setAutoVCComment('This is a candidate for lane repurposing.')
    } else {
      // In case above conditions are not met, do not show any comment
      setAutoVCComment('')
    }
  }, [autoVC])

  // useEffect(() => {
  //   // Update final autoScore , when you have the auto score
  //   if (Object.keys(autoScores).length) {
  //     dispatch(setFinalScores({ field: 'auto', value: autoScores.vc }))
  //   }
  // }, [autoScores])

  useEffect(() => {
    // Re-calculate vc ratio, when capacity assumption or peak hour factor changes
    if (input.id === 'capacity_assumption' || input.id === 'peak_hour_factor') {
      // Calculate VC when component mount
      const vcRatio = calculateVCRatio()
      dispatch(setAutoInputs({ field: 'vc', value: vcRatio }))
      dispatch(setTransitInputs({ field: 'vc', value: vcRatio }))
    }

    if (defaultValue !== '' && input.inputProps) {
      if (
        Number(defaultValue) >= Number(input.inputProps.min) &&
        Number(defaultValue) <= Number(input.inputProps.max)
      ) {
        setErr(false)
      } else {
        setErr(true)
      }
    }
  }, [defaultValue])

  return (
    <Box
      sx={{
        flexGrow: 1,
        gridTemplateColumns: '35% 50% 1fr',
        display: 'grid',
        gap: '10px',
        p: 2,
        borderBottom: '0.1px solid lightgrey'
      }}
    >
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '90% 1fr',
          justifyContent: 'flex-start'
        }}
      >
        <Typography variant="h3" sx={{ alignSelf: 'center' }}>
          {input.name}
        </Typography>
        {/** edit tooltip text based on HCT selected for HCT Amenities */}
        {input.notes && (
          <LightTooltip
            title={input?.id === HCT_AMENITIES ? input?.notes : input?.notes}
            placement="top"
          >
            <IconButton>
              <InfoIcon style={{ color: config.themeConfig.semcogGreen }} />
            </IconButton>
          </LightTooltip>
        )}
      </Box>

      {input.inputType === 'dropDown' ? (
        <>
          <DropDown
            dropDownValues={input.inputValues}
            field={input.id}
            travellerType={travellerType}
          />
        </>
      ) : input.inputType === 'number' || input.inputType === 'string' ? (
        <LightTooltip title={toolTipText} placement="top">
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <TextField
              id={input.id}
              variant={input.autoPopulated ? 'filled' : 'outlined'}
              type={input.inputType}
              disabled={input.autoPopulated}
              value={
                input.id === LAND_USE_CONTEXT
                  ? land_use_context
                  : input.id === TRAVEL_LANES
                  ? travel_lanes
                  : input.id === HIGH_CAPACITY_TRANSIT
                  ? high_capacity_transit
                  : input.id === PREVAILING_POSTED_SPEED
                  ? prevailing_posted_speed
                  : input.id === 'tier'
                  ? defaultModalTier !== 0
                    ? defaultModalTier
                    : 'None'
                  : defaultValue
              }
              error={err}
              inputProps={input.inputProps && input.inputProps}
              onChange={handleChange}
              sx={{
                m: '0.5em',
                width: '100%',

                '& .MuiFilledInput-input': {
                  p: '16.5px 14px'
                }
              }}
            />
            {transitVCComment &&
              travellerType === 'transit' &&
              input.id === VC && (
                <Typography
                  variant="body1"
                  sx={{
                    color: config.themeConfig.semcogBlue1,
                    fontWeight: 600
                  }}
                >
                  {transitVCComment}
                </Typography>
              )}
            {autoVCComment && travellerType === 'auto' && input.id === VC && (
              <Typography
                variant="body1"
                sx={{
                  color: config.themeConfig.semcogBlue1,
                  fontWeight: 600
                }}
              >
                {autoVCComment}
              </Typography>
            )}
          </Box>
        </LightTooltip>
      ) : input.id === HCT_AMENITIES ? (
        <FormGroup sx={{ m: '0.5em', width: '90%', p: 2 }}>
          {' '}
          {/** In case of HCT Amenities, display checkbox values based on selected HCT Amenities facility */}
          {hctAmenitiesValues.map((value, i) => {
            return (
              <CheckBoxComponent
                checkBoxValue={value}
                field={input.id}
                travellerType="transit"
                key={`${value}-${i}`}
              />
            )
          })}
        </FormGroup>
      ) : (
        <FormGroup sx={{ m: '0.5em', width: '90%', p: 2 }}>
          {input.inputValues.map((value, i) => {
            return (
              <CheckBoxComponent
                checkBoxValue={value}
                field={input.id}
                travellerType={travellerType}
                key={`${value}-${i}`}
              />
            )
          })}
        </FormGroup>
      )}
      {input.scores !== null ? (
        <Typography
          variant="body1"
          sx={{
            color: config.themeConfig.lightTextColor,
            fontStyle: 'italic',
            alignSelf: 'center'
          }}
        >
          Score:{' '}
          <span
            style={{
              fontWeight: 700,
              color: config.themeConfig.semcogLightGray,
              fontSize: 20
            }}
          >
            {travellerType === 'bicycle' && input.id === PREVAILING_POSTED_SPEED
              ? bikeSpeedScore
              : travellerType === 'bicycle' && input.id === TRAVEL_LANES
              ? bikeLaneScore
              : travellerType === 'auto' && input.id === 'capacity_assumption'
              ? autoScore
              : travellerType === 'auto' && input.id === 'peak_hour_factor'
              ? autoScore
              : scores[input.id] || scores[input.id] === 0
              ? scores[input.id]
              : ''}
          </span>
        </Typography>
      ) : (
        ''
      )}
    </Box>
  )
}

function DropDown({ dropDownValues, field, travellerType }) {
  const inputValue = useSelector((state) => state[travellerType][field])

  const currentTier = useSelector(
    (state) =>
      state.modalTiers[travellerType[0].toUpperCase() + travellerType.slice(1)]
  )
  const dispatch = useDispatch()
  const { shareableURL } = useSelector((state) => state.appSlice)
  const { high_capacity_transit } = useSelector(
    (state) => state.roadwayVariables
  )

  useEffect(() => {
    // NOTE : If high capacity transit from roadway variables is a NO , then HCT faclity will always be NONE
    if (high_capacity_transit === NO) {
      dispatch(
        setTransitInputs({
          field: HIGH_CAPACITY_TRANSIT_FACILITY,
          value: HIGH_CAPACITY_TRANSIT_FACILITY_VALUES[3]
        })
      )
      setTransitStreetmixInput(field)
    }
  }, [high_capacity_transit])

  useEffect(() => {
    switch (travellerType) {
      case 'pedestrian':
        if (
          field === PEDESTRIAN_FACILITY_TYPE &&
          PEDESTRIAN_FACILITY_TYPE_VALUES.includes(inputValue)
        ) {
          calculatePedestrianScore(field, true)
        } else {
          calculatePedestrianScore(field, false)
        }

        break
      case 'bicycle':
        if (
          field === BIKE_FACILITY_TYPE &&
          BIKE_FACILITY_TYPE_VALUES.includes(inputValue)
        ) {
          calculateBikeScore(field, true)
        } else {
          calculateBikeScore(field, false)
        }
        break
      case 'auto':
        calculateAutoScore()
        break
      case 'freight':
        calculateFreightScore(field)
        break
      case 'transit':
        calculateTransitScore()
        break
      default:
    }
  }, [inputValue])

  function handleClick(value, valueIndex) {
    // If URL is shareable, then remix street adn dispatch URL shareable to false
    if (shareableURL) {
      // remixStreet() -> street remix is done is App.jsx whenever shareableURL is false
      dispatch(setShareableURL(false))
    }

    // NOTE : If high capacity transit from roadway variables is a NO , then HCT faclity will always be NONE
    // NOTE : if Tier is NA/0, do not allow users to change/click-on inputs
    if (
      (high_capacity_transit === NO &&
        field === HIGH_CAPACITY_TRANSIT_FACILITY) ||
      currentTier === 0
    ) {
      return
    }
    switch (travellerType) {
      case 'pedestrian':
        dispatch(setPedestrianInputs({ field, value }))
        setPedestrianStreetmixInput(field)
        if (field === LIGHTING && value && value !== LIGHTING_VALUES[2]) {
          dispatch(setAmenitiesNotSeenOnStreetmix('Lighting'))
          dispatch(
            setTransitInputs({
              field: 'transit_stop_amenities',
              value: TRANSIT_STOP_AMENITIES_VALUES[2]
            })
          )
        } else if (field === LIGHTING && value === LIGHTING_VALUES[2]) {
          dispatch(setAmenitiesNotSeenOnStreetmix('Lighting'))
          dispatch(
            removeTransitStopAmenitiesInput({
              value: TRANSIT_STOP_AMENITIES_VALUES[2]
            })
          )
        }
        break
      case 'bicycle':
        dispatch(setBicycleInputs({ field, value }))
        setbikeStreetmixInput(field)
        break
      case 'auto':
        dispatch(setAutoInputs({ field, value }))
        break
      case 'freight':
        dispatch(setFreightInputs({ field, value }))
        setFreightStreetmixInput(field)
        break
      case 'transit':
        dispatch(setTransitInputs({ field, value }))
        setTransitStreetmixInput(field)

        break
      default:
    }
  }

  return (
    <Box>
      {dropDownValues.map((value, i) => (
        <Box sx={{ position: 'relative' }} key={`${value}-${i}`}>
          {' '}
          {((high_capacity_transit === NO &&
            inputValue !== value &&
            travellerType === 'transit') ||
            currentTier === 0) && (
            <Box
              id="overlay"
              sx={{
                position: 'absolute',
                width: '90%',
                backgroundColor: 'rgba(224,224,224,0.5)',

                borderRadius: '50px',
                p: 2,
                cursor: 'not-allowed',
                margin: '0.5em',
                top: 0,
                bottom: 0
              }}
            >
              <Typography variant="body1" sx={{ visibility: 'hidden' }}>
                {value}
              </Typography>
            </Box>
          )}
          <Box
            sx={
              currentTier !== 0 && inputValue === value
                ? {
                    width: '90%',
                    p: 2,
                    border: '0.1px solid lightgrey',
                    margin: '0.5em',
                    textAlign: 'center',
                    cursor: 'pointer',
                    backgroundColor: config.themeConfig.semcogGreen,
                    borderRadius: '50px'
                  }
                : {
                    width: '90%',
                    p: 2,
                    border: '0.1px solid lightgrey',
                    margin: '0.5em',
                    textAlign: 'center',
                    cursor: 'pointer',
                    borderRadius: '50px'
                  }
            }
            onClick={() => {
              handleClick(value, i)
            }}
            component="button"
          >
            <Typography
              variant="body1"
              sx={
                currentTier !== 0 && inputValue === value
                  ? {
                      color: config.themeConfig.titleTextColor,
                      fontWeight: 600
                    }
                  : {
                      color: config.themeConfig.lightTextColor
                    }
              }
            >
              {value}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  )
}

function CheckBoxComponent({ checkBoxValue, field, travellerType }) {
  const [checked, setChecked] = useState(false)
  const inputValue = useSelector((state) => state[travellerType][field])
  const currentTier = useSelector(
    (state) =>
      state.modalTiers[travellerType[0].toUpperCase() + travellerType.slice(1)]
  )
  const dispatch = useDispatch()
  const { shareableURL } = useSelector((state) => state.appSlice)

  useEffect(() => {
    inputValue.includes(checkBoxValue) ? setChecked(true) : setChecked(false)
    switch (travellerType) {
      case 'pedestrian':
        if (
          field === PEDESTRIAN_FACILITY_TYPE &&
          PEDESTRIAN_FACILITY_TYPE_VALUES.includes(inputValue)
        ) {
          calculatePedestrianScore(field, true)
        } else {
          calculatePedestrianScore(field, false)
        }
        break
      case 'bicycle':
        if (
          field === BIKE_FACILITY_TYPE &&
          BIKE_FACILITY_TYPE_VALUES.includes(inputValue)
        ) {
          calculateBikeScore(field, true)
        } else {
          calculateBikeScore(field, false)
        }
        break
      case 'auto':
        calculateAutoScore()
        break
      case 'freight':
        calculateFreightScore(field)
        break
      case 'transit':
        calculateTransitScore()

        break
      default:
    }
  }, [inputValue, checkBoxValue])

  function handleChange(input) {
    // NOTE : if Tier is NA/0, do not allow users to change/click-on inputs
    if (currentTier === 0) {
      return
    }
    setChecked(!checked)
    const noUpdateTransitInputs = [
      TRANSIT_STOP_AMENITIES_VALUES[0],
      TRANSIT_STOP_AMENITIES_VALUES[1],
      //   TRANSIT_STOP_AMENITIES_VALUES[2],
      TRANSIT_STOP_AMENITIES_VALUES[3],
      TRANSIT_STOP_AMENITIES_VALUES[4],
      TRANSIT_STOP_AMENITIES_VALUES[5],
      TRANSIT_STOP_AMENITIES_VALUES[6],
      TRANSIT_STOP_AMENITIES_VALUES[7],
      TRANSIT_STOP_AMENITIES_VALUES[8],
      TRANSIT_STOP_AMENITIES_VALUES[9],
      TRANSIT_STOP_AMENITIES_VALUES[10]
    ]
    const noUpdatePedestrianInputs = [
      CROSSING_IMPROVEMENTS_VALUES[0],
      CROSSING_IMPROVEMENTS_VALUES[1],
      CROSSING_IMPROVEMENTS_VALUES[2],
      CROSSING_IMPROVEMENTS_VALUES[3],
      CROSSING_IMPROVEMENTS_VALUES[4],
      CROSSING_IMPROVEMENTS_VALUES[5]
    ]
    // If URL is shareable, then remix street adn dispatch URL shareable to false
    if (shareableURL) {
      // remixStreet() -> street remix is done is App.jsx whenever shareableURL is false
      dispatch(setShareableURL(false))
    }
    switch (travellerType) {
      case 'pedestrian':
        dispatch(setPedestrianInputs({ field, value: input }))
        // In case user selects inputs which do not affect streetmix segments , then do not call streetmix update
        if (!noUpdatePedestrianInputs.includes(input)) {
          setPedestrianStreetmixInput(field)
        }

        break
      case 'bicycle':
        dispatch(setBicycleInputs({ field, value: input }))
        setbikeStreetmixInput(field)
        break
      case 'auto':
        dispatch(setAutoInputs({ field, value: input }))
        break
      case 'freight':
        dispatch(setFreightInputs({ field, value: input }))
        break
      case 'transit':
        // HCT AMENITIES
        if (field === HCT_AMENITIES) {
          checked
            ? dispatch(removeHCTAmenitiesInput({ value: input }))
            : dispatch(setTransitInputs({ field, value: input }))

          break
        }

        // If user tries to un-select shelter -> then unselect bench first
        // if (
        //   (input === TRANSIT_STOP_AMENITIES_VALUES[1] && checked) ||
        //   (input === TRANSIT_STOP_AMENITIES_VALUES[0] && checked) ||
        //   (input === TRANSIT_STOP_AMENITIES_VALUES[7] && checked)
        // ) {
        //   dispatch(
        //     removeTransitStopAmenitiesInput({
        //       value: TRANSIT_STOP_AMENITIES_VALUES[7]
        //     })
        //   )
        //   dispatch(
        //     removeTransitStopAmenitiesInput({
        //       value: TRANSIT_STOP_AMENITIES_VALUES[0]
        //     })
        //   )
        //   dispatch(
        //     removeTransitStopAmenitiesInput({
        //       value: TRANSIT_STOP_AMENITIES_VALUES[1]
        //     })
        //   )
        // }
        console.log(checked, input, field)
        checked
          ? dispatch(removeTransitStopAmenitiesInput({ value: input }))
          : dispatch(setTransitInputs({ field, value: input }))

        if (checked && input === TRANSIT_STOP_AMENITIES_VALUES[2]) {
          dispatch(
            setPedestrianInputs({ field: LIGHTING, value: LIGHTING_VALUES[2] })
          )
        } else if (!checked && input === TRANSIT_STOP_AMENITIES_VALUES[2]) {
          dispatch(
            setPedestrianInputs({ field: LIGHTING, value: LIGHTING_VALUES[0] })
          )
        }

        // In case user selects inputs which do not affect streetmix segments , then do not call streetmix update
        if (!noUpdateTransitInputs.includes(input)) {
          setTransitStreetmixInput(field)
        }

        if (
          input === TRANSIT_STOP_AMENITIES_VALUES[1] ||
          input === TRANSIT_STOP_AMENITIES_VALUES[2] ||
          input === TRANSIT_STOP_AMENITIES_VALUES[7] ||
          input === TRANSIT_STOP_AMENITIES_VALUES[8]
        ) {
          dispatch(setAmenitiesNotSeenOnStreetmix(input))
        }
        break
      default:
    }
  }

  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={checked}
          onChange={() => {
            handleChange(checkBoxValue)
          }}
          disabled={currentTier === 0}
          sx={currentTier === 0 ? { cursor: 'not-allowed' } : {}}
        />
      }
      label={checkBoxValue}
    />
  )
}

ModalCriteriaRows.propTypes = {
  input: PropTypes.object,
  travellerType: PropTypes.string
}

DropDown.propTypes = {
  dropDownValues: PropTypes.array,
  field: PropTypes.string,
  travellerType: PropTypes.string
}

ModalCriteria.propTypes = {
  modalConfig: PropTypes.string,
  travellerType: PropTypes.string
}
CheckBoxComponent.propTypes = {
  checkBoxValue: PropTypes.string,
  field: PropTypes.string,
  travellerType: PropTypes.string
}
